const styles = {
    accordionSummary: {
        fontFamily: 'Silka_Semi_Bold',
        '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
            transform: 'rotate(-90deg)',
        },
    },
    accordianDetails: {
        backgroundColor: '#F7F8FC',
        borderTop: '1px solid rgba(0, 0, 0, .125)',
        fontSize: '14px',
        fontFamily: 'Silka_Regular',
    },
    summaryIcon: {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
    },
    bold: {
        fontFamily: 'Silka_Semi_Bold',
        color: '#001533',
        fontSize: '16px',
        fontWight: '600',
    },
    normal: {
        fontFamily: 'Silka_Regular',
        color: '#4D5C71',
        fontSize: '16px',
        fontWight: '400',
    },
};

export default styles;
